.wrap {
  display: flex;
  gap: var(--sp-7);
  align-items: center;
  flex-wrap: wrap;
}
.figure {
  flex-shrink: 0;
}
.centerValue {
  fill: var(--text);
  font-family: var(--font-display);
  font-size: 26px;
  font-weight: 700;
}
.centerLabel {
  fill: var(--text2);
  font-size: 9px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}
.legend {
  display: flex;
  flex-direction: column;
  gap: var(--sp-3);
  min-width: 150px;
}
.row {
  display: flex;
  gap: var(--sp-3);
  align-items: center;
  font-size: 11px;
}
.swatch {
  flex-shrink: 0;
  width: 9px;
  height: 9px;
  border-radius: 2px;
}
.name {
  color: var(--text2);
}
.value {
  margin-left: auto;
  font-family: var(--font-mono);
  font-weight: 600;
  color: var(--text);
}
.segment {
  transition: opacity var(--transition);
}
.segment:hover {
  opacity: 0.78;
}
